import { MemberRoster } from '@/features/members';

export default function TeamRoute() {
  return <MemberRoster />;
}
